import React, { useState } from 'react';
import './ContactForm.css';
import PrimaryButton from './PrimaryButton';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((currentState) => ({
      ...currentState,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject = encodeURIComponent(
      `Website inquiry from ${formData.name || 'a reader'}`
    );
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\n${formData.message}`
    );

    window.location.href = `mailto:skysprowles@yahoo.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className='contact-form-card'>
      <div className='contact-form-card__header'>
        <p className='contact-form-card__eyebrow'>Send a note</p>
        <h2>Draft an email</h2>
        <p className='contact-form-card__intro'>
          Fill this out and your default mail app will open with everything
          prefilled.
        </p>
      </div>
      <form className='contact-form' onSubmit={handleSubmit}>
        <div className='contact-form__field'>
          <label htmlFor='name'>
            <span>Name</span>
            <span>*</span>
          </label>
          <input
            type='text'
            name='name'
            id='name'
            required
            value={formData.name}
            onChange={handleChange}
            autoComplete='name'
            autoCapitalize='words'
            placeholder='Your name'
          />
        </div>

        <div className='contact-form__field'>
          <label htmlFor='email'>
            <span>Email</span>
            <span>*</span>
          </label>
          <input
            type='email'
            name='email'
            id='email'
            required
            value={formData.email}
            onChange={handleChange}
            autoComplete='email'
            placeholder='you@example.com'
          />
        </div>

        <div className='contact-form__field'>
          <label htmlFor='message'>
            <span>Message</span>
            <span>*</span>
          </label>
          <textarea
            name='message'
            id='message'
            required
            value={formData.message}
            onChange={handleChange}
            rows='7'
            placeholder='Tell Schuyler what you are reaching out about.'
          ></textarea>
        </div>
        <PrimaryButton as='button' type='submit' label='Open Email Draft' />
      </form>
    </div>
  );
}
